import TileWMS from "ol/source/TileWMS.js";
import TileLayer from "ol/layer/Tile";
import { rooApiUrl, workspaceName } from "../environment/Environment";

export const createWMSLayer = (layerName, visible = true, zIndex = 1) => {
  if (!layerName) return null;
  return new TileLayer({
    visible,
    source: new TileWMS({
      url: `${rooApiUrl}/wms`,
      params: { TILED: true, LAYERS: `${workspaceName}:${layerName}` },
      serverType: "geoserver",
      crossOrigin: "Anonymous",
    }),
    zIndex,
  });
};

export const buildCountryLayers = (countryDto) => {
  if (!countryDto) return {};

  return {
    country: createWMSLayer(countryDto.countryLayerName, true, 1),
    region: createWMSLayer(countryDto.regionLayerName, true, 2),
    district: createWMSLayer(countryDto.districtLayerName, true, 3),
    outRecls: createWMSLayer(countryDto.outReclsLayerName, true, 4),
    lulc: createWMSLayer(countryDto.lulcLayerName, true, 5),
    urbanRoads: createWMSLayer(countryDto.urbanRoadsLayerName, true, 6),
    rainfall: createWMSLayer(countryDto.rainfallLayerName, true, 7),
    settlement: createWMSLayer(countryDto.settlementLayerName, true, 8),
    suitability: createWMSLayer(countryDto.suitabilityLayerName, true, 9),
    landuse: createWMSLayer(countryDto.landuseLayerName, true, 10),
    elevation: createWMSLayer(countryDto.elevationLayerName, true, 11),
    road: createWMSLayer(countryDto.roadLayerName, true, 12),
  };
};
